import { PayloadAction } from "@reduxjs/toolkit";
import { logEvent } from "firebase/analytics";
import { all, takeEvery } from "redux-saga/effects";
import { analytics } from "../../../config/firebase";
import { AnalyticsEvent, trackEvent } from "./analyticsSlice";

function* handleTrackEvent(action: PayloadAction<AnalyticsEvent>) {
  if (!analytics) {
    console.log("Analytics event:", action.payload);
    return;
  }

  yield logEvent(analytics, action.payload.name, action.payload.params);
}

export default function* analyticsSaga() {
  yield all([takeEvery(trackEvent.type, handleTrackEvent)]);
}
